var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19800.865 -13890.419 14.992 10.451"}},[_c('path',{attrs:{"d":"M-19799.714-13885.244l4.051 4.126 8.64-8.151","fill":"none","stroke":"#2386db","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"2.3"}})])};var toString = function () {return "/Library/WebServer/Documents/iwp-vue-client/iwp-vue-client/src/assets/tick.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/tick.svg
// module id = NeOv
// module chunks = 3